<template>
  <wh-popup-dynamic-select
    :label="label"
    :value="staffName"
    :extra-params="extraParams"
    search-name="name"
    :show-picker.sync="pickerShow"
    :placeholder="placeholder"
    history-key="staffList"
    data-src="/api/getStaffList"
    :rules="rules"
  >
    <template #list="{list}">
      <div class="staff-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="staff-list-item wh-flex-between van-hairline--bottom"
          :title="index"
          @click="selectStaff(item)"
        >
          <div class="staff-name">
            {{ item.name }}
          </div>
          <div class="time">
            {{ item.updatedAt }}
          </div>
        </div>
      </div>
    </template>
  </wh-popup-dynamic-select>
</template>

<script>
import WhPopupDynamicSelect from '@/components/public/WhPopupSelect/WhPopupDynamicSelect'
export default {
  name: 'StaffPopupSelect',
  components: { WhPopupDynamicSelect },
  props: {
    value: {
      type: String,
      default: undefined
    },
    rules: {
      type: Array,
      default() {
        return []
      }
    },
    label: {
      type: String,
      default: '负责人'
    },
    placeholder: {
      type: String,
      default: '请选择员工'
    },
    staffName: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      extraParams: {
        fuzzy: 1
      },
      pickerShow: false
    }
  },
  methods: {
    selectStaff(item) {
      // console.log('item = ', item)
      this.pickerShow = false // 隐藏选择弹窗
      this.$emit('update:staffName', item.name)
      this.$emit('selectStaff', item)
    }
  }
}
</script>

<style lang='less' scoped>
.staff-list {
  .staff-list-item {
    margin: 10px;
    padding: 10px;
  }
  .time {
    font-size: 12px;
    color: #ccc;
  }
}
</style>
